import styled from '../../../utils/styling/styled';

export const SVG = styled.svg`
  fill: currentColor;
`;
